import { render } from "./Audiences.vue?vue&type=template&id=6be6d9ce&scoped=true"
import script from "./Audiences.vue?vue&type=script&lang=js"
export * from "./Audiences.vue?vue&type=script&lang=js"

import "./Audiences.vue?vue&type=style&index=0&id=6be6d9ce&scoped=true&lang=css"
import "./Audiences.vue?vue&type=style&index=1&id=6be6d9ce&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be6d9ce"]])

export default __exports__